<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">{{ title }}</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <form class="flex flex-wrap gap-4" @submit="sendData" method="POST">

                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label class="block text-sm font-medium leading-6 text-gray-900">Empresa Consignante</label>
                    <input v-model="empresaBusca" @input="buscarEmpresas" :disabled="!!data.id" type="text" placeholder="Digite para buscar Empresas..." class="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm disabled:bg-gray-100 disabled:text-gray-500" />
                    <select v-model="data.empresa_id" id="empresa_id" name="empresa_id" :disabled="!!data.id" class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:bg-gray-100" required>
                      <option value="">Selecione uma empresa</option>
                      <option v-for="e in empresas" :key="e.id" :value="e.id">{{ e.nome }}</option>
                    </select>
                  </div>

                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label class="block text-sm font-medium leading-6 text-gray-900">Seguradora Parceira</label>
                    <input v-model="seguradoraBusca" @input="buscarSeguradoras" :disabled="!!data.id" type="text" placeholder="Digite para buscar Seguradoras..." class="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm disabled:bg-gray-100 disabled:text-gray-500" />
                    <select v-model="data.seguradora_id" id="seguradora_id" name="seguradora_id" :disabled="!!data.id" class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:bg-gray-100">
                      <option value="">Selecione uma seguradora (Opcional)</option>
                      <option v-for="s in seguradoras" :key="s.id" :value="s.id">{{ s.nome }}</option>
                    </select>
                  </div>

                  <div class="w-full">
                    <label class="block text-sm font-medium leading-6 text-gray-900 font-bold">Planos Vinculados</label>
                    <div class="flex gap-2">
                       <div class="w-full">
                         <input v-model="planoBusca" @input="buscarPlanos" type="text" placeholder="Digite para buscar Planos..." class="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm" />
                         <ul v-if="planos.length" class="absolute z-60 mt-1 border border-gray-300 rounded-md bg-white shadow-lg p-2 max-h-40 overflow-y-auto w-1/2">
                           <li v-for="p in planos" :key="p.id" @click="adicionarPlano(p)" class="cursor-pointer hover:bg-gray-100 p-2 rounded text-sm text-gray-700">
                             {{ p.nome }}
                           </li>
                         </ul>
                       </div>
                    </div>

                    <!-- Lista de Planos Selecionados -->
                    <div class="mt-4 border rounded-md p-4 bg-gray-50">
                      <h3 class="text-sm font-semibold text-gray-800 mb-2">Planos na Apólice</h3>
                      <ul class="space-y-2">
                        <li v-for="(p, index) in data.planos" :key="index" class="flex justify-between items-center bg-white px-3 py-2 rounded-md shadow-sm border border-gray-200">
                          <span :class="{ 'opacity-50 line-through text-red-500': p.marcado_remocao }" class="text-sm font-medium text-gray-700">
                            {{ p.nome }}
                          </span>
                          <div class="flex items-center gap-2">
                            <span v-if="p.marcado_remocao" class="text-xs text-red-500 font-bold bg-red-100 px-2 py-1 rounded">
                              Para remover
                            </span>
                            <button v-if="!p.marcado_remocao" @click.prevent="removerPlano(index)" class="text-red-500 hover:text-red-700">
                              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                              </svg>
                            </button>
                            <button v-else @click.prevent="desfazerRemocaoPlano(index)" class="text-green-600 text-xs underline hover:text-green-800">
                              Desfazer
                            </button>
                          </div>
                        </li>
                      </ul>
                      <p v-if="!data.planos || data.planos.length === 0" class="text-xs text-gray-400 italic mt-2">Nenhum plano selecionado</p>
                    </div>
                  </div>

                  <div class="flex-1 min-w-[150px] sm:min-w-[150px] lg:w-1/5">
                    <label class="block text-sm font-medium leading-6 text-gray-900">Encampação</label>
                    <select v-model="data.encampacao" class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                      <option :value="1">Sim</option>
                      <option :value="0">Não</option>
                    </select>
                  </div>
                  <div class="flex-1 min-w-[150px] sm:min-w-[150px] lg:w-1/5">
                    <label class="block text-sm font-medium leading-6 text-gray-900">Permite Venda</label>
                    <select v-model="data.permite_venda" class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                      <option :value="1">Sim</option>
                      <option :value="0">Não</option>
                    </select>
                  </div>
                  <div class="flex-1 min-w-[150px] sm:min-w-[150px] lg:w-1/5">
                    <label class="block text-sm font-medium leading-6 text-gray-900">Cancelada</label>
                    <select v-model="data.cancelada" class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                      <option :value="1">Sim</option>
                      <option :value="0">Não</option>
                    </select>
                  </div>
                  <div class="flex-1 min-w-[150px] sm:min-w-[150px] lg:w-1/5">
                    <label class="block text-sm font-medium leading-6 text-gray-900">Mês de Cálculo IPCA</label>
                    <select v-model="data.calc_mes_ipca" class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                      <option value="">Nenhum</option>
                      <option :value="1">Janeiro</option>
                      <option :value="2">Fevereiro</option>
                      <option :value="3">Março</option>
                      <option :value="4">Abril</option>
                      <option :value="5">Maio</option>
                      <option :value="6">Junho</option>
                      <option :value="7">Julho</option>
                      <option :value="8">Agosto</option>
                      <option :value="9">Setembro</option>
                      <option :value="10">Outubro</option>
                      <option :value="11">Novembro</option>
                      <option :value="12">Dezembro</option>
                    </select>
                  </div>
                  <div
                    v-for="(input, index) in inputsList"
                    :key="index"
                    class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2"
                  >
                    <label
                      :for="input.name"
                      class="block text-sm font-medium leading-6 text-gray-900"
                    >
                      {{ input.label }}
                    </label>

                    <!-- Select -->
                    <select
                      v-if="input.type === 'select'"
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    >
                      <option value="">Selecione uma opção</option>
                      <option
                        v-for="(opt, i) in input.options"
                        :key="i"
                        :value="opt"
                      >
                        {{ opt }}
                      </option>
                    </select>

                    <!-- Textarea -->
                    <textarea
                      v-else-if="input.type === 'textarea'"
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      rows="3"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    ></textarea>

                    <!-- Input normal -->
                    <input
                      v-else
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      :type="input.type"
                      :readonly="input.readonly || false"
                      :required="true"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                   <!-- Campos dinâmicos gerados por extraInputs -->
                    <div v-if="extraInputs" class="flex gap-4 flex-wrap">
                      <!-- Iterar sobre cada extraInput para gerar o campo -->
                      <div v-for="(input, index) in extraInputs" :key="index" class="flex-1 min-w-[200px]">
                        <label :for="input.name" class="block text-sm font-medium leading-6 text-gray-900">{{ input.label }}</label> 
                        <input
                          v-model="extraObect[input.name]"
                          :id="input.name"
                          :name="input.name"
                          :type="input.type"
                          :required="false"
                          class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>        

                  <!-- Botão de adicionar novo conjunto de campos dinâmicos -->
                  <div v-if="extraInputs" class="w-full">
                    <button @click.prevent="addExtraField" type="button" class="mt-2 w-full flex justify-center rounded-md bg-green-500 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-400">Adicionar {{ extraInputName }}</button>
                  </div>
                  <!-- Botão de enviar formulário -->
                   <div v-if="Object.keys(data.extraFields).length">
                    <DynamicTable
                      :extraFields=" this.data.extraFields"
                      @remove-item="removeExtraField"
                    />
                   </div>
                  <div class="w-full">
                    <button type="submit" class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500">Cadastrar</button>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import DynamicTable from '@/components/generalcomponents/DynamicTable.vue';
import PlanosRepository from '@/services/PlanosRepository.vue';
import EmpresasRepository from '@/services/EmpresasRepository.vue';
import SeguradoraRepository from '@/services/SeguradoraRepository.vue';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import debounce from 'lodash/debounce';

  export default {
    name: 'ApolicesForm',
    created(){
        this.buscarPlanos = debounce((...args) => { this._buscarPlanos(...args); }, 400);
        this.buscarEmpresas = debounce((...args) => { this._buscarEmpresas(...args); }, 400);
        this.buscarSeguradoras = debounce((...args) => { this._buscarSeguradoras(...args); }, 400);
    },
    props: {
      inputsList: {
        type: Array,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      open: {
        type: Boolean,
        required: true
      },
      extraInputs:
      {
        type: Array,
        required: false
      },
      resetFormData:{
        type: Boolean,
        required:true
      },
      extraInputName: {
        type: String,
        required: false
      },
      placeHolderValues: {
        type: Object,
        required: false
      }
    },  
    watch: {
      resetFormData(newValue) { 
        if(newValue == true){
          this.data = {
            extraFields:[],
            planos: []
          }
          this.planoBusca = '';
          this.planosMarcadosRemocao = [];
        }
      },
      placeHolderValues: {
        handler(newValue) {
          if (newValue && Object.keys(newValue).length > 0) {
            // Cria uma cópia profunda para não afetar o original e garantir reatividade
            const cleanData = JSON.parse(JSON.stringify(newValue));
            
            // Converte calc_mes_ipca para número se vier como string ou vice-versa, dependendo do que o select espera
            // Os options usam :value="1", então esperamos número
            if (cleanData.calc_mes_ipca !== null && cleanData.calc_mes_ipca !== undefined) {
                cleanData.calc_mes_ipca = Number(cleanData.calc_mes_ipca);
            }

            this.data = Object.assign({}, this.data, cleanData);
            
            // Mapeia os planos caso venham do backend como 'planos'
            if (newValue.planos) {
                this.data.planos = newValue.planos.map(p => ({
                    id: p.id,
                    nome: p.nome,
                    marcado_remocao: false,
                    id_persistido: true
                }));
            } else {
                this.data.planos = [];
            }

            if (!this.data.extraFields) this.data.extraFields = [];
            
            this.planosMarcadosRemocao = [];
            this.empresaBusca = newValue.empresa && newValue.empresa.nome ? newValue.empresa.nome : (newValue.empresa_nome || '');
            this.seguradoraBusca = newValue.seguradora && newValue.seguradora.nome ? newValue.seguradora.nome : (newValue.seguradora_nome || '');
            
            if (newValue.empresa_id) {
                this.empresas = [{id: newValue.empresa_id, nome: this.empresaBusca}];
            }
            if (newValue.seguradora_id) {
                this.seguradoras = [{id: newValue.seguradora_id, nome: this.seguradoraBusca}];
            }

            this.planoBusca = '';
          }
        },
        deep: true,
        immediate: true
      }
    },
    data() {
      return {
        data:
        {  
          extraFields:[],
          planos: [],
          empresa_id: '',
          seguradora_id: '',
          numero: '',
          encampacao: 0,
          permite_venda: 1,
          cancelada: 0,
          calc_mes_ipca: ''
        },
        planosMarcadosRemocao: [],
        extraObect:{},
        planos:[],
        planoBusca:'',
        empresas: [],
        empresaBusca: '',
        seguradoras: [],
        seguradoraBusca: '',
        onlineUser: JSON.parse(window.localStorage.getItem("myUser") || "{}"),
      };
    },
    methods: {
      sendData(e) {
        e.preventDefault();
        
        let payload = JSON.parse(JSON.stringify(this.data));
        
        // Separa os planos que são novos para adicionar
        // E os que já existiam para sincronizar ou não remover
        payload.planos_adicionar = payload.planos.filter(p => !p.id_persistido && !p.marcado_remocao).map(p => p.id);
        payload.planos_remover = this.planosMarcadosRemocao;
        
        // Se formos usar sync total, basta mandar planos_ids com os ativos
        payload.planos_ids = payload.planos.filter(p => !p.marcado_remocao).map(p => p.id);

        if (this.data.id) {
          this.$emit('editing-data', payload, this.data.id);
        } else {
          this.$emit('data', payload);
        }
      },
      closeDialog() {
        this.$emit('update-open', false);
      },
      addExtraField() {
        this.data.extraFields.push(this.extraObect);
        this.extraObect = {}
      },
      removeExtraField(index) {
        this.data.extraFields.splice(index, 1);
      },

      adicionarPlano(plano) {
        // Evita duplicados
        if (this.data.planos.find(p => p.id === plano.id)) {
          return;
        }

        this.data.planos.push({
          id: plano.id,
          nome: plano.nome,
          id_persistido: false, // Marca como novo (local)
          marcado_remocao: false
        });
        
        this.planoBusca = '';
        this.planos = [];
      },

      removerPlano(index) {
        let plano = this.data.planos[index];
        // Se o plano já existe no banco (não é novo local), marca para remoção
        if (plano.id_persistido !== false) {
          plano.marcado_remocao = true;
          this.planosMarcadosRemocao.push(plano.id);
        } else {
          // Se for novo local, só remove do array
          this.data.planos.splice(index, 1);
        }
      },

      desfazerRemocaoPlano(index) {
        let plano = this.data.planos[index];
        plano.marcado_remocao = false;
        this.planosMarcadosRemocao = this.planosMarcadosRemocao.filter(id => id !== plano.id);
      },

      async getPlanos(query) {
        this.loading = true;
        const planoRepo = new PlanosRepository();
        try {
          const response = await planoRepo.getPlanoQuery(this.onlineUser.token, query);
          if (response?.status === 200) {
            this.loading = false;
            this.planos = response.data;
          } else {
            this.loading = false;
            this.error = response?.message;
          }
        } catch (error) {
          this.loading = false;
          handleUnauthorized(error);
        }
      },

      async _buscarPlanos() {
        if (!this.planoBusca || this.planoBusca.length < 4) {
          this.planos = [];
          return;
        }
        this.getPlanos(this.planoBusca);
      },

      async getEmpresas(query) {
        this.loading = true;
        const repo = new EmpresasRepository();
        try {
          const response = await repo.getEmpresaQuery(this.onlineUser.token, query);
          if (response?.status === 200) { this.empresas = response.data; }
        } catch (error) { handleUnauthorized(error); } finally { this.loading = false; }
      },
      async _buscarEmpresas() {
        if (!this.empresaBusca || this.empresaBusca.length < 4) { this.empresas = []; return; }
        this.getEmpresas(this.empresaBusca);
      },

      async getSeguradoras(query) {
        this.loading = true;
        const repo = new SeguradoraRepository();
        try {
          const response = await repo.getSeguradoraQuery(this.onlineUser.token, query);
          if (response?.status === 200) { this.seguradoras = response.data; }
        } catch (error) { handleUnauthorized(error); } finally { this.loading = false; }
      },
      async _buscarSeguradoras() {
        if (!this.seguradoraBusca || this.seguradoraBusca.length < 4) { this.seguradoras = []; return; }
        this.getSeguradoras(this.seguradoraBusca);
      },
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot,
      DynamicTable
    },
  }
</script>